var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25143_12291)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.33329 15.8333V11.6666H11.6666V15.8333C11.6666 16.2916 12.0416 16.6666 12.5 16.6666H15C15.4583 16.6666 15.8333 16.2916 15.8333 15.8333V9.99998H17.25C17.6333 9.99998 17.8166 9.52498 17.525 9.27498L10.5583 2.99998C10.2416 2.71664 9.75829 2.71664 9.44163 2.99998L2.47496 9.27498C2.19163 9.52498 2.36663 9.99998 2.74996 9.99998H4.16663V15.8333C4.16663 16.2916 4.54163 16.6666 4.99996 16.6666H7.49996C7.95829 16.6666 8.33329 16.2916 8.33329 15.8333Z",
    fill: "#84849A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25143_12291"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home-icon.84e17b45.svg";
export { ForwardRef as ReactComponent };